import BaseEntity from '../database/BaseEntity.js';

/**
 * Audio Entity
 * Represents a Audio in the system
 *
 * Built-in fields (auto-generated):
 * - id: Unique identifier
 * - createdAt: Creation timestamp
 * - updatedAt: Last update timestamp
 * - createdBy: Email of user who created the record
 */
class Audio extends BaseEntity {
  static collectionName = 'audios';
  static _schema = JSON.parse("{\"name\":\"Audio\",\"type\":\"object\",\"properties\":{\"titulo\":{\"type\":\"string\",\"description\":\"Título de la canción o audio\"},\"url_audio\":{\"type\":\"string\",\"description\":\"URL del archivo de audio (mp3, etc.)\"},\"artista\":{\"type\":\"string\",\"description\":\"Nombre del artista o grupo\"},\"album\":{\"type\":\"string\",\"description\":\"Nombre del álbum\"},\"descripcion\":{\"type\":\"string\",\"description\":\"Descripción del audio\"},\"categoria\":{\"type\":\"string\",\"enum\":[\"Salsa\",\"Cumbia\",\"Vallenato\",\"Pop\",\"Rock\",\"Reggaeton\",\"Tropical\",\"Variedad\"],\"default\":\"Variedad\",\"description\":\"Categoría musical\"},\"portada\":{\"type\":\"string\",\"description\":\"URL de la imagen de portada\"},\"duracion\":{\"type\":\"string\",\"description\":\"Duración del audio (ej: 3:45)\"},\"activo\":{\"type\":\"boolean\",\"default\":true,\"description\":\"Si el audio está activo\"},\"orden\":{\"type\":\"number\",\"description\":\"Orden de aparición\"}},\"required\":[\"titulo\",\"url_audio\"]}");
}

export { Audio };
export default Audio;
